// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGetMb } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const requestInitMBTranslationsSuccess = (translations) => {
    return {
        type: actionTypes.INIT_MB_TRANSLATIONS_SUCCESS,
        payload: {
            translations: translations || {}
        }
    }
}
const requestInitMBTranslationsError = (error) => {
    return {
        type: actionTypes.INIT_MB_TRANSLATIONS_ERROR,
        payload: {
            error
        }
    }
}
const requestInitMBTranslationsFetch = () => {
    return {
        type: actionTypes.INIT_MB_TRANSLATIONS_REQUEST,
    }
}

const requestInitMBTranslations = () => (dispatch, getState) => {
    const immInitMBTranslations= getState().initMBTranslations;
    const hasBeenFetched = immInitMBTranslations.get('hasBeenFetched');
    const isFetching = immInitMBTranslations.get('isFetching');

    if ((hasBeenFetched || isFetching)){
        return Promise.resolve();
    }

    dispatch(requestInitMBTranslationsFetch());
    return Promise.all([
        APIGetMb(dispatch, apiURLBuilder.getModelURL('initMBTranslationsWeb')),
        APIGetMb(dispatch, apiURLBuilder.getModelURL('initMBTranslationsConfig'))
    ])
    .then(([responseWeb, responseConfig]) => {
    return Promise.all([
        APIGetMb(dispatch, responseWeb.downloadUrl),
        APIGetMb(dispatch, responseConfig.downloadUrl)
    ]);
})
    .then(([responseWebFinal, responseConfigFinal]) => {
        dispatch(requestInitMBTranslationsSuccess({ web: responseWebFinal?.entries, config: responseConfigFinal?.entries }));
    })
    .catch((error) => {
        dispatch(requestInitMBTranslationsError(error));
    });
}

module.exports = {
    requestInitMBTranslations,
    requestInitMBTranslationsSuccess,
};
